import { render, staticRenderFns } from "./businessOwnerSettingGeneral.vue?vue&type=template&id=779af085&scoped=true"
import script from "./businessOwnerSettingGeneral.vue?vue&type=script&lang=js"
export * from "./businessOwnerSettingGeneral.vue?vue&type=script&lang=js"
import style0 from "./businessOwnerSettingGeneral.vue?vue&type=style&index=0&id=779af085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779af085",
  null
  
)

export default component.exports